import { Link } from 'react-router';
import { formatEur, type Bundle } from '@/data/pricing';
import { ArrowUpRight } from '@/icons';

type Props = {
  bundle: Bundle;
};

export function BundleCard({ bundle }: Props) {
  const savings = bundle.priceOriginal - bundle.priceFrom;
  return (
    <article className="flex flex-col lg:flex-row items-start lg:items-center gap-6 lg:gap-12 py-10 border-b border-border">
      <div className="flex-1 min-w-0">
        <h3 className="font-display text-3xl md:text-4xl font-medium">{bundle.name}</h3>
        <p className="text-ink-secondary mt-2 max-w-xl leading-relaxed">{bundle.description}</p>
        <ul className="flex flex-wrap gap-x-6 gap-y-2 mt-4">
          {bundle.components.map((c) => (
            <li key={c} className="mono-meta text-ink-muted">
              {c}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col items-start lg:items-end gap-1 shrink-0">
        <span className="mono-meta text-ink-muted line-through">{formatEur(bundle.priceOriginal)}</span>
        <div className="flex items-baseline gap-2">
          <span className="font-display text-5xl font-semibold tracking-tight">
            {formatEur(bundle.priceFrom)}
          </span>
        </div>
        <span className="mono-meta text-accent">Save {formatEur(savings)}</span>
      </div>
      <Link
        to="/contact"
        className="inline-flex items-center gap-2 bg-accent text-bg px-6 py-3 rounded-full font-semibold hover:bg-accent-hover transition-all duration-200"
      >
        Choose <ArrowUpRight className="w-4 h-4" />
      </Link>
    </article>
  );
}
